
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "TravelAgency",
        "@id": `${siteUrl}/#organization`,
        "name": "Ecoffetours",
        "description": "Agencia de turismo especializada en ecoturismo, senderismo, avistamiento de aves y camping en el páramo de Ocetá, Mongua, Boyacá",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Calle 5 # 6 14",
          "addressLocality": "Mongua",
          "addressRegion": "Boyacá",
          "addressCountry": "Colombia",
          "postalCode": "150001"
        },
        "telephone": ["+57 310 254 7961", "+57 311 890 3404"],
        "email": "ecoffetours@gmail.com",
        "url": siteUrl,
        "sameAs": [
          "https://www.instagram.com/ecoffetours_agenciadeturismo",
          "https://www.facebook.com/people/Ecoffetours/100063618908701"
        ],
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "5.755702464161156",
          "longitude": "-72.79978042553051"
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday", 
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "08:00",
          "closes": "18:00"
        },
        "areaServed": [
          {
            "@type": "Place",
            "name": "Páramo de Ocetá"
          },
          {
            "@type": "Place", 
            "name": "Mongua, Boyacá, Colombia"
          }
        ],
        "serviceType": ["Ecoturismo", "Senderismo", "Avistamiento de Aves", "Camping", "Tours Páramo de Ocetá", "Guías Turísticos"]
      },
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#localbusiness`,
        "name": "Ecoffetours",
        "description": "Agencia de turismo especializada en tours al páramo de Ocetá, senderismo en Ocetá y ecoturismo en Mongua, Boyacá",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Calle 5 # 6 14",
          "addressLocality": "Mongua",
          "addressRegion": "Boyacá",
          "addressCountry": "Colombia",
          "postalCode": "150001"
        },
        "telephone": ["+57 310 254 7961", "+57 311 890 3404"],
        "email": "ecoffetours@gmail.com",
        "url": siteUrl,
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "5.755702464161156",
          "longitude": "-72.79978042553051"
        },
        "priceRange": "$$",
        "paymentAccepted": "Cash, Credit Card, Bank Transfer",
        "currenciesAccepted": "COP"
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "Ecoffetours - Agencia Turismo Páramo de Ocetá",
        "description": "Agencia de turismo especializada en ecoturismo en el páramo de Ocetá, Mongua, Boyacá",
        "publisher": {
          "@id": `${siteUrl}/#organization`
        },
        "inLanguage": "es-CO",
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${siteUrl}/?s={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "Ecoffetours - Agencia Turismo",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#organization`
        },
        "description": "Ecoffetours agencia de turismo en Mongua Boyacá especializada en ecoturismo, senderismo, avistamiento de aves y camping. Páramo de Ocetá, senderismo en Ocetá, ecoturismo Mongua.",
        "inLanguage": "es-CO",
        "mainEntity": {
          "@id": `${siteUrl}/#organization`
        }
      },
      {
        "@type": "Service",
        "name": "Tours Páramo de Ocetá",
        "description": "Experiencias únicas de ecoturismo, senderismo en Ocetá, avistamiento de aves y camping en el páramo de Ocetá, Mongua, Boyacá",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": [
          {
            "@type": "Place",
            "name": "Páramo de Ocetá"
          },
          {
            "@type": "Place",
            "name": "Mongua, Boyacá, Colombia"
          }
        ],
        "serviceType": ["Ecoturismo", "Senderismo en Ocetá", "Avistamiento de Aves", "Camping", "Tours Páramo", "Guías Turísticos Páramo"],
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "COP"
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "¿Qué es el páramo de Ocetá?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "El páramo de Ocetá es uno de los ecosistemas de alta montaña más hermosos de Colombia, ubicado en Mongua, Boyacá. Es famoso por sus frailejones dorados, lagunas cristalinas y biodiversidad única."
            }
          },
          {
            "@type": "Question",
            "name": "¿Cómo llegar al páramo de Ocetá desde Mongua?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Desde Mongua se puede acceder al páramo de Ocetá mediante senderismo guiado. Nuestros guías expertos locales conocen las mejores rutas y horarios para disfrutar del páramo de manera segura."
            }
          },
          {
            "@type": "Question",
            "name": "¿Qué incluyen los tours de senderismo en Ocetá?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nuestros tours de senderismo en Ocetá incluyen guía experto local, transporte desde Mongua, equipos de seguridad, refrigerios y la experiencia completa de ecoturismo en el páramo."
            }
          },
          {
            "@type": "Question",
            "name": "¿Cuál es la mejor época para visitar el páramo de Ocetá?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "La mejor época para el senderismo en Ocetá es durante la temporada seca (diciembre a marzo y julio a agosto), cuando hay menos lluvia y mejor visibilidad para disfrutar del páramo."
            }
          }
        ]
      }
    ]
  };

  useEffect(() => {
    // Agregar datos estructurados al head
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      // Limpiar al desmontar
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">Ecoffetours - Agencia de Turismo Páramo de Ocetá Mongua Boyacá</h1>
      </header>
      <main>
        <div id="inicio">
          <Hero />
        </div>
        <div id="nosotros">
          <About />
        </div>
        <div id="servicios">
          <Services />
        </div>
        <div id="galeria">
          <Gallery />
        </div>
        <div id="contacto">
          <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
